/* Independent editor/runtime helpers; no store data or side effects. */
(() => {
 'use strict';
 const windows=(hour,flags={})=>Boolean(flags[['night','morning','afternoon','evening'][Math.floor(hour/6)]]);
 const numeric=value=>{if(!String(value??'').trim())return null;const n=Number(String(value).replaceAll(',',''));return Number.isFinite(n)?n:null;};
 const safeURL=(value,base)=>{try{const url=new URL(value,base);return ['http:','https:'].includes(url.protocol)?url:null;}catch{return null;}};
 const api={windows,numeric,safeURL};if(typeof module==='object'&&module.exports)module.exports=api;else window.PawStudioCore=api;
})();
